require('./brokerStocksAdvancedSellStep2.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const moment = require('moment');
const classNames = require('classnames');

// @ helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const {
    FIRST_STEP,
    SECOND_STEP,
    BROKER_STOCKS_ADVANCED_SELL_FIELDS_MAXLENGHT_LIMIT,
    BROKER_STOCKS_CONTRACT_DROPDOWN_TITLES_MODIFIER,
    BROKER_ORDER_TYPE_TO_MARKET,
    BROKER_ORDER_TYPE_FOR_THE_BEST,
    BROKER_ORDER_TYPE_LIMITED,
    BROKER_RESTRICTED_ORDER_TERM,
    SPANISH_CONTINUES_MARKET_ISO_CODE_ONLY_STOCK,
    SPANISH_CONTINUES_MARKET_ISO_CODE,
    MAX_FRACTION_LENGTH_IN_STORE_LIMITED,
    NON_NUMERIC_REGEXP
} = require('constants/index');
const language = getLanguage();
const { DATE_PICKER_CUSTOM_PLACEHOLDER, DATE_PICKER_CUSTOM_LOCALE, DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');

// @ commons
const StocksContractDropdown = require('components/broker/commons/stocksContractDropdown/stocksContractDropdown');
const { InputSafe } = require('commonsComponents/inputSafe');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');

// @ actions
const BrokerStocksAdvancedSellActions = require('actions/brokerStocksAdvancedSell');

// @ components
const { AmountInput } = require('commonsComponents/amountInput');

// @ utils
const { formatAmount } = require('utilities/currencyHelper');

class BrokerStocksAdvancedSellStep2 extends React.Component {
    constructor(props) {
        super(props);
        this.handleTitleQuantityChanged = this.handleTitleQuantityChanged.bind(this);
        this.handleStockContractChanged = this.handleStockContractChanged.bind(this);
    }

    componentDidMount() {
        const { immBrokerStocksAdvancedSell, handleValidityDateChanged } = this.props;
        const step1 = immBrokerStocksAdvancedSell.get('steps').get(FIRST_STEP);
        let initialValidityDate;

        //If it is a restricted order then we will have validity date for the purchase
        if (step1.get('orderTerms') === BROKER_RESTRICTED_ORDER_TERM) {
            initialValidityDate = moment().add(90, 'days');
        }
        handleValidityDateChanged(initialValidityDate);

        const step2 = immBrokerStocksAdvancedSell.get('steps').get(SECOND_STEP);
        const titleQuantity = step2.get('titleQuantity');

        const stocksContractDropdownOptions = this.buildStocksContractDropdownOptions();
        if (stocksContractDropdownOptions.length === 1 && !titleQuantity) {
            this.handleStockContractChanged(stocksContractDropdownOptions[0].contactNumber);
        }

    }

    getStockCode() {
        const { immProductFile, immMyInvestments } = this.props;
        const stock = immMyInvestments.getIn(['products', 'stocks', 'stocks']).find(stock => {
            return immProductFile.get('isinCode') === stock.get('isin') &&
                immProductFile.get('micCode') === stock.get('iso');
        }
        );
        const stockCode = stock ? stock.get('valueCode') + stock.get('emisionCode') : '';
        return stockCode;
    }

    buildOrderTypeBlock() {
        const { immBrokerStocksAdvancedSell, onOrderTypeChanged, iso, immProductFile } = this.props;
        const limitedLabel = immProductFile.get('catalogData').get('operatedByLot') ?
            (
                <div className="stocks-advanced-sell-step2__input-foot">
                    {formatText('brokerOperacionPorLotes-brokerOperacionPorLotes_titleLimitPrice')}
                </div>
            ) : null;
        const step2 = immBrokerStocksAdvancedSell.get('steps').get(SECOND_STEP);
        const loadingStep = step2.get('loading');
        const orderType = step2.get('orderTypeOption');
        let handleOrderTypeChange;
        const toMarketRadioButton = (
            <RadioButton
                label={formatText('broker-stocksAdvancedSellStep2ToMarketLabel')}
                value={BROKER_ORDER_TYPE_TO_MARKET}
                className="stocks-advanced-sell-step2__radio-button"
            />
        );
        const forTheBestRadioButton = (
            <RadioButton
                label={formatText('broker-stocksAdvancedSellStep2ForTheBestLabel')}
                value={BROKER_ORDER_TYPE_FOR_THE_BEST}
                className="stocks-advanced-sell-step2__radio-button"
            />
        );
        const limitedRadioButton = (
            <RadioButton
                label={formatText('broker-stocksAdvancedSellStep2LimitedLabel', [
                    immBrokerStocksAdvancedSell.get('productCurrency')
                ])}
                value={BROKER_ORDER_TYPE_LIMITED}
                className="stocks-advanced-sell-step2__radio-button"
            />
        );
        const forTheBestOptionPresent =
            iso === SPANISH_CONTINUES_MARKET_ISO_CODE_ONLY_STOCK ||
            iso === SPANISH_CONTINUES_MARKET_ISO_CODE;

        let limitedInput;
        let radioButtonGroup;

        if (orderType === BROKER_ORDER_TYPE_LIMITED) {
            limitedInput = this.conditionalInput(forTheBestOptionPresent, limitedLabel);
        }

        if (!loadingStep) {
            handleOrderTypeChange = onOrderTypeChanged;
        }

        //We can't just render a radio button group with a conditional "for the best" radio button because
        //when it doesn't apply (not spanish market) the variable is null and the radio button group component explodes.
        if (forTheBestOptionPresent) {
            radioButtonGroup = (
                <RadioButtonGroup
                    selectedValue={orderType}
                    onChange={handleOrderTypeChange}
                    name="stocksAdvancedSellOrderType"
                    idPrefix="stocksAdvancedSellOrderType"
                >
                    {toMarketRadioButton}
                    {forTheBestRadioButton}
                    {limitedRadioButton}
                </RadioButtonGroup>
            );
        } else {
            radioButtonGroup = (
                <RadioButtonGroup
                    selectedValue={orderType}
                    onChange={handleOrderTypeChange}
                    name="stocksAdvancedSellOrderType"
                    idPrefix="stocksAdvancedSellOrderType"
                >
                    {toMarketRadioButton}
                    {limitedRadioButton}
                </RadioButtonGroup>
            );
        }

        return (
            <div className="stocks-advanced-sell-step2__group-div">
                <h2 className="stocks-advanced-sell-step2__subtitle">
                    <FormattedText value="broker-stocksAdvancedSellStep2OrderTypeTitle" />
                    <OKTooltip
                        offset={[0, -15]}
                        content="broker-stocksAdvancedSellOrderTypeTooltip"
                    />
                </h2>
                {radioButtonGroup}
                {limitedInput}
            </div>
        );
    }

    buildStocksContractDropdownOptions() {
        const stockCode = this.getStockCode();
        const filteredContracts = this.filterContracts(stockCode);

        const processedStocksContract = filteredContracts.map(entry => {
            const newEntry = entry.merge({
                value: entry.get('contactNumber'),
                titlesQuantity: entry.getIn(['stocks', stockCode, 'sellables'])
            });

            return newEntry;
        });

        return processedStocksContract.toJS();
    }

    buildValidityDateBlock(validityDate, limitDate) {
        const { handleValidityDateChanged } = this.props;

        return (
            <div className="stocks-advanced-sell-step2__group-div">
                <h4 className="stocks-advanced-sell-step2__subtitle">
                    <FormattedText value="broker-stocksAdvancedSellStep2ValidityDate" />
                    <OKTooltip
                        offset={[0, -15]}
                        content="broker-todoTooltip"
                    />
                </h4>
                <DatePickerCustom
                    callback={handleValidityDateChanged}
                    selectedDate={validityDate}
                    maxDate={limitDate}
                    placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                    locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                    dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                />
            </div>
        );
    }

    conditionalInput(forTheBestOptionPresent, limitedLabel) {
        const { immBrokerStocksAdvancedSell, limitedValueChanged } = this.props;
        const limitedValue = immBrokerStocksAdvancedSell
            .get('steps')
            .get(SECOND_STEP)
            .get('orderTypeValue');
        const orderTypeValueValid =
            immBrokerStocksAdvancedSell.get('steps').get(SECOND_STEP).get('orderTypeValueValid') !==
                undefined
                ? immBrokerStocksAdvancedSell
                    .get('steps')
                    .get(SECOND_STEP)
                    .get('orderTypeValueValid')
                : true;
        const wrapperClasses = classNames('stocks-advanced-sell-step2__text-input-wrapper', {
            'stocks-advanced-buy-step2__text-input-wrapper--small-margin': !forTheBestOptionPresent
        });
        const limitMsg = orderTypeValueValid ? limitedLabel : null;

        return (
            <div className={wrapperClasses}>
                <AmountInput
                    id="limitedValue"
                    callback={limitedValueChanged}
                    hideFocusZero={true}
                    amount={limitedValue}
                    error={!orderTypeValueValid}
                    errorMsg={formatText('broker-stocksBuyStep1NoLimitedAmmount')}
                    maxBackEndFractionLength={MAX_FRACTION_LENGTH_IN_STORE_LIMITED}
                    language={language}
                />
                {limitMsg}
            </div>
        );
    }

    filterContracts(valueCode) {
        const { immStocksContract } = this.props;
        const filteredContracts = immStocksContract.filter(entry => {
            return entry.getIn(['stocks', valueCode]);
        });
        return filteredContracts;
    }

    handleStockContractChanged(value) {

        const { immStocksContract, immBrokerStocksAdvancedSell } = this.props;
        const stockCode = this.getStockCode();
        const selectedContract = immStocksContract.find(entry => {
            return entry.get('contactNumber') === value;
        });

        const contractTitles = selectedContract.getIn(['stocks', stockCode, 'sellables'])
        this.props.stockContractChanged(value, contractTitles);
        const titleChangedManually = immBrokerStocksAdvancedSell.getIn(['steps', SECOND_STEP, 'titleChangedManually']);
        if (!titleChangedManually) {
            this.props.titleQuantityChanged(contractTitles, false);
        }

    }

    handleTitleQuantityChanged(event) {
        this.props.titleQuantityChanged(event.target.value.replace(NON_NUMERIC_REGEXP, "").trim(), true);
    }

    render() {
        const { immBrokerStocksAdvancedSell, immProductFile } = this.props;
        const stocksContractDropdownOptions = this.buildStocksContractDropdownOptions();
        const comboDisabled = stocksContractDropdownOptions.length === 1;
        const orderTypeBlock = this.buildOrderTypeBlock();
        const step2 = immBrokerStocksAdvancedSell.get('steps').get(SECOND_STEP);
        const stocksContractSelectedValue = step2.get('selectedOptionValue');
        const stocksContractPlaceholder = formatText('broker-stocksContractDropdownPlaceholder');
        const titleQuantity = step2.get('titleQuantity');
        let catalogData = immProductFile.get('catalogData');
        let operatedByLotLabel;
        let tooltipLot;
        let titleQuantityValid = step2.get('titleQuantityValid', true);
        const titleQuantityLimitValid = step2.get('titleQuantityLimitValid', true);
        const orderTypeValid = step2.get('orderTypeValid', true);
        const validityDate = step2.get('validityDate');
        const limitDate = step2.get('limitDate');
        let validityDateBlock;

        let titleQuantityErrorMessage = formatText('broker-stocksAdvancedSellTitleQuantityMin');

        if (!titleQuantityLimitValid) {
            titleQuantityErrorMessage = formatText('broker-stocksAdvancedSellTitleQuantityMax');
        }

        if (validityDate) {
            validityDateBlock = this.buildValidityDateBlock(validityDate, limitDate);
        }

        if(catalogData.get('operatedByLot')){
            let titleQuantityNotMultiplo = step2.getIn(['errorFlags','notMultiploLote']);
            let titleQuantityMinorThanLote = step2.getIn(['errorFlags','minorThanLote']);
            const valueLabel = formatAmount(Number((titleQuantity * catalogData.get('lotValue') / catalogData.get('lot')).toFixed(3)), undefined, 3);
            const lot = formatAmount(catalogData.get('lot'), undefined, 0);

            tooltipLot = (
                <OKTooltip
                    content="brokerOperacionPorLotes-brokerOperacionPorLotes_operatedByLots"
                    offset={[0, -5]}
                />
            );

            if (titleQuantityNotMultiplo && !titleQuantityMinorThanLote) {
                titleQuantityValid = false;
                titleQuantityErrorMessage = formatText('brokerOperacionPorLotes-brokerOperacionPorLotes_notMultiplo');
            }
            if (titleQuantityMinorThanLote) {
                titleQuantityValid = false;
                titleQuantityErrorMessage = <FormattedText value="brokerOperacionPorLotes-brokerOperacionPorLotes_notEnoughTitlesForLotError" injectedStrings={[lot]}/>;
            }
            if(!titleQuantityNotMultiplo && !titleQuantityMinorThanLote) {
                operatedByLotLabel = <FormattedText className="stocks-advanced-sell-step2__input-foot" value="brokerOperacionPorLotes-brokerOperacionPorLotes_buyByTitle" injectedStrings={[lot, valueLabel]}/>;
            }

        }

        return (
            <div className="stocks-advanced-sell-step2">
                <header className="stocks-advanced-sell-step2__header">
                    <h2 className="stocks-advanced-sell-step2__header-title">
                        <FormattedText value="broker-stocksAdvancedSellStep2HeaderTitle" />
                    </h2>
                </header>
                <FormattedText
                    value="broker-stocksAdvancedSellStep2InstructionsText"
                    className="stocks-advanced-sell-step2__info-text"
                />
                <div className="stocks-advanced-sell-step2__dropdown">
                    <StocksContractDropdown
                        onStockContractChange={this.handleStockContractChanged}
                        options={stocksContractDropdownOptions}
                        selectedValue={stocksContractSelectedValue}
                        placeholder={stocksContractPlaceholder}
                        modifier={BROKER_STOCKS_CONTRACT_DROPDOWN_TITLES_MODIFIER}
                        disabled={comboDisabled}
                        errorState={!orderTypeValid}
                        errorMessage={formatText('broker-stocksAdvancedSellAccountError')}
                    />
                </div>
                <div className="stocks-advanced-sell-step2__group-div">
                    <h2 className="stocks-advanced-sell-step2__subtitle">
                        <FormattedText value="broker-stocksAdvancedSellStep2TitleQuantityText" />
                        {tooltipLot}
                    </h2>
                    <div className="stocks-advanced-sell-step2__text-input-wrapper stocks-advanced-sell-step2__text-input-wrapper--left">
                        <InputSafe
                            type="text"
                            value={titleQuantity}
                            autoComplete="off"
                            onChange={this.handleTitleQuantityChanged}
                            maxLength={BROKER_STOCKS_ADVANCED_SELL_FIELDS_MAXLENGHT_LIMIT}
                            errorState={!titleQuantityValid || !titleQuantityLimitValid}
                            errorMessage={titleQuantityErrorMessage}
                        />
                        {operatedByLotLabel}
                    </div>
                </div>
                {orderTypeBlock}
                {validityDateBlock}
            </div>
        );
    }
}

BrokerStocksAdvancedSellStep2.propTypes = {
    immBrokerStocksAdvancedSell: PropTypes.object.isRequired,
    immStocksContract: PropTypes.object.isRequired,
    immProductFile: PropTypes.object.isRequired,
    immMyInvestments: PropTypes.object.isRequired,
    stockContractChanged: PropTypes.func.isRequired,
    titleQuantityChanged: PropTypes.func.isRequired,
    onOrderTypeChanged: PropTypes.func.isRequired,
    limitedValueChanged: PropTypes.func.isRequired,
    handleValidityDateChanged: PropTypes.func.isRequired,
    isin: PropTypes.string.isRequired,
    iso: PropTypes.string.isRequired
};

module.exports.constructor = BrokerStocksAdvancedSellStep2;

module.exports.BrokerStocksAdvancedSellStep2 = connect(
    state => ({
        immProductFile: state.brokerProductFile,
        immMyInvestments: state.brokerMyInvestments
    }),
    {
        stockContractChanged: BrokerStocksAdvancedSellActions.stockContractChanged,
        titleQuantityChanged: BrokerStocksAdvancedSellActions.titleQuantityChanged,
        onOrderTypeChanged: BrokerStocksAdvancedSellActions.orderTypeChanged,
        limitedValueChanged: BrokerStocksAdvancedSellActions.limitedValueChanged,
        handleValidityDateChanged: BrokerStocksAdvancedSellActions.validityDateChanged
    }
)(BrokerStocksAdvancedSellStep2);
